import cn from 'classnames';
import { useEffect, useMemo, useState } from 'react'
import Checkbox from '../../customize-button/components/form/Checkbox';
import { useSelector } from 'react-redux';
import { createPortal } from 'react-dom';
import { t } from '../../../utilities/translator';

const DepartureStepDesktop = ({
  fromWhereGroups,
  stepConfig,
  handleCheckbox,
  onContinueClick,
}) => {
  const { formV2: form } = useSelector(state => state.onboarding);
  const nonEmptyGroups = useMemo(() => Object.keys(fromWhereGroups).filter(group => form.departure.some(dep => {
    return dep.group_id === +group
  })), [form.departure.length, fromWhereGroups]);
  const [activeGroup, setActiveGroup] = useState(+nonEmptyGroups[0]);
  const footerPortal = document.getElementById('wizard-next-button');

  useEffect(() => {
    setActiveGroup(parseInt(nonEmptyGroups[0]))
  }, [nonEmptyGroups])

  return (
    <div className="self-start mt-10">
      <p className="mb-8 heading-large text-primary">{stepConfig.title}</p>
      <div className="departure-groups">
        {nonEmptyGroups.map(index =>
          <div
            className={cn('departure-group-tab', {
              'departure-group-tab--active': activeGroup === +index
            })}
            onClick={() => setActiveGroup(+index)}
            key={index}
          >
            {t(`mainFilter.${fromWhereGroups[index]}`)}
          </div>
        )}
      </div>
      <div className="departures-list">
        {form.departure.filter(dep => dep.group_id === activeGroup).map((dep, index) => (
          <div key={index}>
            <Checkbox
              key={dep.id+index}
              label={<>{dep.value} <span>{dep.id}</span></>}
              checked={dep.active}
              onChange={() => handleCheckbox(dep.id)}
            />
          </div>
        ))}
      </div>

      {footerPortal && createPortal(
        <button className="wizard-btn wizard-btn--next" onClick={onContinueClick}>
          {stepConfig.buttonText}
          <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
        </button>,
        footerPortal
      )}
    </div>
  )
}

export default DepartureStepDesktop
